/* ---------------------------------------------------------------------------
   UF BENEFITS — the "what are you taking it for?" tabs.

   A real tablist, so this implements what the pattern promises: click to
   select, arrow keys to move between tabs, Home/End to jump to the ends, and
   roving tabindex so Tab moves past the whole group rather than through every
   tab in it.

   Local to its section. Several of these can sit on one page without knowing
   about each other.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ufBenefitsBound) return;
  window.__ufBenefitsBound = true;

  function tabsIn(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('[data-uf-benefit-tab]')
    );
  }

  function select(section, index, moveFocus) {
    tabsIn(section).forEach(function (tab) {
      var isCurrent = tab.getAttribute('data-uf-benefit-tab') === String(index);
      tab.setAttribute('aria-selected', String(isCurrent));
      /* Roving tabindex: only the selected tab is reachable with Tab, which is
         what stops a five-benefit group swallowing five presses. */
      tab.tabIndex = isCurrent ? 0 : -1;
      if (isCurrent && moveFocus) tab.focus();
    });

    Array.prototype.slice
      .call(section.querySelectorAll('[data-uf-benefit-panel]'))
      .forEach(function (panel) {
        var isCurrent = panel.getAttribute('data-uf-benefit-panel') === String(index);
        panel.toggleAttribute('data-uf-benefit-hidden', !isCurrent);
      });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('[data-uf-benefit-tab]');
    if (!tab) return;

    var section = tab.closest('[data-uf-benefits]');
    if (!section) return;

    select(section, tab.getAttribute('data-uf-benefit-tab'), false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-uf-benefit-tab]');
    if (!tab) return;

    var section = tab.closest('[data-uf-benefits]');
    if (!section) return;

    var tabs = tabsIn(section);
    var at = tabs.indexOf(tab);
    var next = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = tabs[(at + 1) % tabs.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = tabs[(at - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        next = tabs[0];
        break;
      case 'End':
        next = tabs[tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    select(section, next.getAttribute('data-uf-benefit-tab'), true);
  });
})();
